import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import { 
  Button, 
  Dialog, 
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  MenuItem
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

// URIs
import serverURI from '../../../../../config/URI';

import { IsNoU } from 'common/utils';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    row: {
        //height: '82px',
        display: 'flex',
        alignItems: 'center',
        '& > *': {
        margin: theme.spacing(1),
        },
    },
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    registerListItemTitle: {
        marginLeft: theme.spacing(2),
        width: '100px',
    },
    registerListItemInput: {
        //marginLeft: theme.spacing(2),
        width: '240px',
        //height: '40px',
    },
    registerListItemFilePath: {
        //marginLeft: theme.spacing(2),
        width: '640px',
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviewDialog = (props) => {

    const classes = useStyles();

    const { 
        openDialog, 
        onClickCloseDialog,
        template,
        advertiseName,
        advertiseMovieURL,
        advertiseMovie,
        advertiseImageURL,
        advertiseImage,
    } = props;

    return (
        <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              광고 미리보기
            </Typography>
          </Toolbar>
        </AppBar>

        <List>
          <ListItem>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              광고명
            </Typography>
            <TextField
              className={classes.registerListItemInput}
              id="outlined-basic1" 
              //variant="outlined"
              value={advertiseName}
              disabled={true}
              margin="dense" />
          </ListItem>
          <Divider />
          <ListItem>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              첨부파일
            </Typography>
            <TextField
              className={classes.registerListItemFilePath}
              id="outlined-basic1" 
              //variant="outlined"
              value={template === 'image' ? advertiseImage : advertiseMovie}
              disabled={true}
              margin="dense" />
          </ListItem>
          <Divider />
          <ListItem>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              URL
            </Typography>
            <TextField
              className={classes.registerListItemFilePath}
              id="outlined-basic1" 
              //variant="outlined"
              value={template === 'image' ? advertiseImageURL : advertiseMovieURL}
              disabled={true}
              margin="dense" />
          </ListItem>
          <Divider />
          <ListItem>
            { template !== 'image' && (
              <div 
                className={classes.row}>
                <video
                  controls={false}
                  autoPlay="autoplay"
                  loop="loop"
                  width="640"
                  //onclick={() => {}}
                  // style={{ display: "none" }}
                  // onLoadedMetadata={e => {
                  //     setMetadata({
                  //     videoHeight: e.target.videoHeight,
                  //     videoWidth: e.target.videoWidth,
                  //     duration: e.target.duration
                  //     });
                  // }}
                  >
                  <source src={serverURI+advertiseMovieURL} type="video/mp4" />
                </video>
                {!IsNoU(advertiseImage) && advertiseImage.length > 0 ?
                  (<img 
                    src={serverURI+advertiseImageURL} 
                    width="100"
                    />)
                  :
                  ('')
                }
                
              </div>
            )}
            { template === 'image' && (
              <div 
                className={classes.row}>
                {!IsNoU(advertiseImage) && advertiseImage.length > 0 ?
                  (<img 
                    src={serverURI+advertiseImageURL} 
                    width="640"
                    height="480"
                    />)
                  :
                  ('')
                }
                
              </div>
            )}
          </ListItem>
          <Divider />
        </List>
      </Dialog>
    )
}

export default PreviewDialog;